<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
				  <el-breadcrumb-item>个人信息</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<ul class="userbox">
				<li>
					<div class="userbox1">
						<div>头像</div>
						<img :src="user.avatar" alt="" srcset="" />
					</div>
					<input
						ref="avatarInput"
						type="file"
						accept="image/*"
						style="display:none"
						@change="onAvatarFileChange"
					/>
					<p @click="touxiang">更换头像</p>
				</li>
				<li>
					<div class="userbox1">
						<div>昵称</div>
						<span>{{user.nickname}}</span>
					</div>
					<p @click="geteast">编辑昵称</p>
				</li>
				<li>
					<div class="userbox1">
						<div>手机号码</div>
						<span>{{user.phone}}</span>
					</div>
					<p></p>
				</li>
				<li v-if="brokerage=='1'">
					<div class="userbox1">
						<div>邀请好友</div>
						<span>分享好友</span>
					</div>
					<p @click="fenxiang" style="cursor:pointer;">生成邀请链接</p>
				</li>
			</ul>
			
			<div class="userbox" style="margin-top:15px;">
				<div class="fuwuxinxi">
					<h3>服务信息</h3>
					<span @click="bianji" v-if="!bj" style="font-size: 16px;color: #4297FF;">编辑</span>
					<span @click="bianji2"  v-if="bj" style="font-size: 16px;color: #4297FF;">保存</span>
				</div>
				<div class="fuwuxinxi2"> 
					<div class="fuwuxinxi3">
						<span>工作年限</span>
						<p v-if="!bj">{{user.work_year_name}}</p>
						<el-select v-model="editWorkYear" placeholder="请选择" style="width:100%;" v-if="bj">
						    <el-option
						      v-for="(item,index) in work_year"
						      :key="index"
						      :label="item.name"
						      :value="item.dict_value">
						    </el-option>
						</el-select>
					</div>
					<div  class="fuwuxinxi3">
						<span>行业标准</span>
						<div style="display:flex;" v-if="!bj">
							<template>
								<p v-for="(i,index) in user.userIndustries" :key="i.id || i.dict_value || i.name || index" style="margin-right:5px;">{{i.name}}</p>
							</template>
						</div>
						<el-select
						     v-if="bj"
							 v-model="editUserIndustries" 
							 :multiple-limit="5"
							 multiple 
							 placeholder="请选择擅长技能" 
							 style="width:100%;">
						    <el-option
						      v-for="(item,index) in industry"
						      :key="index"
						      :label="item.name"
						      :value="item.dict_value">
						    </el-option>
						  </el-select>
					</div>
				</div>
			</div>
			<diV class="userbox" 
			     style="margin-top:20px;
				        display:flex;
						justify-content:space-between;
						align-items: center;">
				<div class="userboxTj"  @click="xieyi(4)">
					<h4>是否加入评审团参与纠纷调解</h4>
					<p>参与评审团可获得评审金奖励</p>
				</div>
				<el-switch
					  v-model="value"
					  @change="switch2Change"
					  active-color="#1E3A8A"
					  inactive-color="#cccccc">
				</el-switch>
			</diV>
			<div style="padding-top:10px;width:100%;display:flex;justify-content:end;">
				<p>
					<span @click="xieyi(1)" style="cursor:pointer;">《隐私政策》</span>
					<span @click="xieyi(2)" style="cursor:pointer;">《用户协议》</span>
					<span @click="xieyi(3)" style="cursor:pointer;">《平台协议》</span>
					<span @click="xieyi(4)" style="cursor:pointer;">《评审说明》</span>
					<span @click="xieyi(5)" style="cursor:pointer;">《分销规则》</span>
				</p>
			</div>
			<div class="FBxqFooter">
				<div class="FBxqFooter1" @click="tuichu">退出登录</div>
			</div>
		</div>
		<el-dialog
		  title="修改昵称"
		  :visible.sync="centerDialogVisible"
		  width="400px"
		  center>
		  <el-input v-model="inputname" placeholder="请输入新的昵称"></el-input>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="getname">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
	import {
		UserUpdate,
		upload,
		dictValue,
		setIdentity,
		BaseGetConfig
	} from "@/api/api.js"
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	 //  components:{
		// rightsidebarImg  
	 //  },
	  data() {
	    return {
			radio:'1',
			type: true,
			bj:false,
			value: false,
			centerDialogVisible:false,
			inputname:"",
			valiFormData: {
				company_name: '',
				tax_id:'',
				email:"",
			},
			industry:[],
			work_year:[],
			editWorkYear:"",
			editUserIndustries:[],
			ids:[],
			brokerage:""
        }
	  },
	  computed: {
		...mapState({
			user: (state) => state.userInfo || {}
		})
	  },
	  created() {
	  	this.userinfo()
		this.getdictValue()
		this.getfenxiang()
	  },
	  methods: {
		getfenxiang(){
		  	BaseGetConfig({
		  		key:"brokerage_switch"
		  	}).then(res=>{
		  		this.brokerage=res.data.data.brokerage_switch
		  	})
		},
		getdictValue(){
		  	dictValue({
		  		key:"industry,work_year"
		  	}).then(res=>{
		  		this.industry=res.data.data.industry
		  		this.work_year=res.data.data.work_year
		  		this.work_year.forEach(item =>{
		  			item.text=item.name
		  			item.value=item.dict_value
		  		})
		  	})
		},
		  bianji(){
			if(!this.bj){
				this.initEditEcho()
				this.bj=true
			}else{
				this.applyEditValueToUser()
				this.bj=false
			}
		  },
		  bianji2(){
			  this.applyEditValueToUser()
			  this.bj=false
			 // this.xuanze=false
			 // console.log(this.valiFormData.dict_value)
			 // console.log(this.i_ids)
			 // setIdentity({
			 // 	work_year: this.valiFormData.dict_value, // 使用正确的值
			 // 	i_ids: this.i_ids,
			 // 	review_status:this.user.review_status
			 // }).then(res => {
			 // 	if(res.status==200){
			 // 		uni.$u.toast("提交成功！")
			 // 		this.userinfo()
			 // 	}
			 // }) 
		  },
		  xiugai(){
			setIdentity({
			  	work_year:this.user.work_year, // 使用正确的值
			  	i_ids: this.ids.join(),
				review_status:this.value
			  }).then(res => {
			  	if(res.data.status==200){
			  		this.$message.success("保存成功！")
			  		this.userinfo()
			  	}else{
					// this.$message.error(res.data.msg)
				}
			  }) 
		  },
		  initEditEcho(){
		  	this.editWorkYear = this.normalizeWorkYearValue(this.user.work_year)
		  	this.editUserIndustries = this.normalizeIndustryValues(this.user.userIndustries)
		  },
		  normalizeWorkYearValue(value){
		  	if(value === null || value === undefined || value === '') return ''
		  	const byDict = this.work_year.find(item => String(item.dict_value) === String(value))
		  	if(byDict) return byDict.dict_value
		  	const byName = this.work_year.find(item => item.name === value)
		  	if(byName) return byName.dict_value
		  	return value
		  },
		  normalizeIndustryValues(userIndustries){
		  	if(!Array.isArray(userIndustries)) return []
		  	return userIndustries.map(item => {
		  		if(item && typeof item === 'object'){
		  			const rawValue = item.dict_value || item.value || item.name || ''
		  			const byDict = this.industry.find(i => String(i.dict_value) === String(rawValue))
		  			if(byDict) return byDict.dict_value
		  			const byName = this.industry.find(i => i.name === rawValue)
		  			return byName ? byName.dict_value : rawValue
		  		}
		  		const byDict = this.industry.find(i => String(i.dict_value) === String(item))
		  		if(byDict) return byDict.dict_value
		  		const byName = this.industry.find(i => i.name === item)
		  		return byName ? byName.dict_value : item
		  	}).filter(Boolean)
		  },
		  applyEditValueToUser(){
		  	this.user.work_year = this.editWorkYear
		  	const selectedWorkYear = this.work_year.find(item => String(item.dict_value) === String(this.editWorkYear))
		  	this.user.work_year_name = selectedWorkYear ? selectedWorkYear.name : this.user.work_year_name
		  	this.user.userIndustries = this.industry.filter(item => this.editUserIndustries.includes(item.dict_value))
			this.ids=[]
			this.user.userIndustries.forEach(res=>{
				this.ids.push(res.dict_value)
			})
			this.xiugai()
		  },
		  xieyi(e){
		  		this.$router.push('/Agreement?type='+e)
		  },
		  fenxiang(){
		  			let text='https://demandweb.jckj928.cn/?invite_code='+this.user.invite_code
		  			try {
		  				navigator.clipboard.writeText(text);
		  				this.$message.success('生成邀请链接成功')
		  			} catch (err) {
		  				this.$message.error('生成邀请链接失败')
		  			}
		  },
		touxiang(){
			this.$refs.avatarInput && this.$refs.avatarInput.click()
		},
		onAvatarFileChange(e) {
			const input = e.target
			const file = input.files && input.files[0]
			input.value = ''
			if (!file) return
			if (!/^image\//.test(file.type)) {
				this.$message.warning('请选择图片文件')
				return
			}
			const maxSize = 2 * 1024 * 1024
			if (file.size > maxSize) {
				this.$message.warning('图片大小不能超过 2MB')
				return
			}
			const formData = new FormData()
			formData.append('file', file)
			upload(formData, {
				transformRequest: [
					(data, headers) => {
						if (data instanceof FormData) {
							delete headers['Content-Type']
						}
						return data
					}
				]
			}).then((res) => {
				if(res.data.status==200){
					this.getUserUpdate(res.data.data)
				}else{
					 // this.$message.error(res.data.msg)
				}
			})
		},
		// 更新个人信息
		getUserUpdate(img){
			UserUpdate({
				avatar:img
			}).then(res=>{
				if(res.data.status==200){
					this.userinfo()
				}else{
					// this.$message.error(res.data.msg)
				}
			})
		},
		userinfo(){
		    return this.$store.dispatch('fetchPersonal').then(() => {
			const u = this.user
			if (u && u.review_status == 1) {
				this.value = true
			} else {
				this.value = false
			}	
			})
		},
		tuichu(){
		   // 清理登录态与缓存
		   localStorage.removeItem("token")
		   localStorage.removeItem("userinfo")
		   localStorage.setItem("userType","1")
		   sessionStorage.clear()
		   // 提示并返回首页，尽可能避免保留历史记录
		   this.$message.success('退出登录成功')
		   setTimeout(()=>{
		   	 // 路由层替换当前记录
		   	 this.$router.replace('/')
		   	 // 浏览器层替换，阻断后退到受保护页
		   	 this.$nextTick(()=>{
		   	 	window.location.replace('/')
		   	 })
		   },800)
		},
		onChooseAvatar(e) {
			this.avatarUrl = e.detail.avatarUrl;
			// uni.uploadFile({
			// 	url:APIIMG+'api/Upload/upload',
			// 	filePath,
			// 	method: 'POST',
			// 	name: 'file',
			// 	success: (res) => {
			// 		let img=JSON.parse(res.data)
			// 		this.content_image=img.data
			// 		if(this.content_image){
			// 			this.setuserinfo()
			// 		}
			// 	},
			// 	fail: (uploadFileErr) => {
			// 		// console.log(uploadFileErr,"fanhui")
			// 	}
			// });
		},
		switch2Change(){
			let review_status=""
			if(this.value==true){
				review_status="1"
			}
			if(this.value==false){
				review_status="0"
			}
			UserUpdate({
				review_status:review_status
			}).then(res=>{
				console.log(res)
				this.userinfo()
			})
		},
		geteast(){
		  this.inputname=''
		  this.centerDialogVisible=true
		},
		getname(){
			  if(this.inputname==''){
				  this.$message.error("新的昵称不能为空")
				  return false
			  }
			  UserUpdate({
				nickname:this.inputname
			  }).then(res=>{
				if(res.data.status==200){
					this.centerDialogVisible=false
					this.userinfo()
				}else{
					// this.$message.error(res.data.msg)
				}
			  })
		},
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.userbox{
		width:100%;
		background-color:#fff;
		padding:12px;
		box-sizing: border-box;
		border-radius:12px;
	}
	.userbox img{
		width: 42px;
		height:42px;
		border-radius:50%;
	}
	.userbox li{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		padding: 10px 0px;
	}
	.userbox1{
		display:flex;
		align-items: center;
	}
	.userbox1 div{
		width: 160px;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.userbox1 span{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}
	.userbox li>p{
		font-weight: 500;
		font-size: 16px;
		color: #4297FF;
		cursor:pointer;
	}
	.userboxTj h4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.userboxTj p{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.FBxqFooter{
		width:100%;
		padding:30px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.FBxqFooter1{
		width: 160px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #1E3A8A;
		cursor:pointer;
	}
	.FBxqFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px ;
		margin-left:32px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
	.fuwuxinxi{
		width:100%;
		display:flex;
		align-items: center;
		justify-content:space-between;
	}
	.fuwuxinxi>span{
		cursor: pointer;
	}
	.fuwuxinxi2{
      margin-top:10px;
	}
	.fuwuxinxi3{
		width:100%;
		height:55px;
		display:flex;
		align-items: center;
	}
	.fuwuxinxi3 span{
		display:inline-block;
		width:160px;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.fuwuxinxi3 p{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}
</style>